import { BADGE_PULSE_ANIMATION_MS, BADGE_PULSE_SCALE } from "../constant";

export const badgePulseStyles = {
  badgePulse: {
    animation: `badgePulse ${BADGE_PULSE_ANIMATION_MS}ms ease-in-out`,
  },
  "@keyframes badgePulse": {
    "0%": {
      transform: "scale(1)",
    },
    "50%": {
      transform: `scale(${BADGE_PULSE_SCALE})`,
    },
    "100%": {
      transform: "scale(1)",
    },
  },
} as const;
